/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/

/**
 * This interface helps to handle the parameters for a plc mapping
 * @class IPlcMappingPack
 * @author insite-gmbh
 */
export interface IPlcMappingPack {
    /**
     * This is the name for the new mapping.
     *
     * @property Variable
     * @type {string}
     */
    Variable: string;

    /**
     * This is the name of the mapped c# type for this area  (see INAX for more details).
     *
     * @property Type
     * @type {string}
     */
    Type: string;

    /**
     * This is the area selector in where the variables are.
     *
     * @property Selector
     * @type {string}
     */
    Selector: string;

    /**
     * This is the offest in byte.
     *
     * @property Offset
     * @type {number}
     */
    Offset: number;

    /**
     * This is the cycle in ms in wich we check the data changes.
     *
     * @property ObservationRate
     * @type {number}
     */
    ObservationRate: number;
}

/**
 * This class is the implementation to handle the parameters for a plc mapping
 * @class PlcMappingPack
 * @author insite-gmbh
 */
export class PlcMappingPack implements IPlcMappingPack {
    /**
     * This is the name for the new mapping.
     *
     * @property Variable
     * @type {string}
     */
    Variable: string;

    /**
     * This is the name of the mapped c# type for this area  (see INAX for more details).
     *
     * @property Type
     * @type {string}
     */
    Type: string;

    /**
     * This is the area selector in where the variables are.
     *
     * @property Selector
     * @type {string}
     */
    Selector: string;

    /**
     * This is the offest in byte.
     *
     * @property Offset
     * @type {number}
     */
    Offset: number;

    /**
     * This is the cycle in ms in wich we check the data changes.
     *
     * @property ObservationRate
     * @type {number}
     */
    ObservationRate: number;
}
